import React from "react";
import Link from "next/link";

import LazyImage from "ui/LazyImage/LazyImage";

import { useImage, useUrl } from "helpers/hooks";

import { cn } from "helpers/style";
import {
  IMAGE_SIZE_0_210,
  IMAGE_SIZE_1024_768,
  IMAGE_SIZE_600_600,
} from "constants/variables";
import styles from "./Item.module.scss";

type Props = {
  type: string;
  article: Entity.Blog.Article;
};

const Item: React.FC<Props> = ({ type = "default", article }: Props) => {
  const { getEntityLinkProps } = useUrl();

  // TODO: Change to image.src when BE will be ready
  const croppedSrc = useImage(article.image.l.url, {
    mobile: type === "default" ? IMAGE_SIZE_600_600 : IMAGE_SIZE_0_210,
    tablet: type === "default" ? IMAGE_SIZE_1024_768 : IMAGE_SIZE_600_600,
  });

  return (
    <Link
      {...getEntityLinkProps("article", article)}
      className={cn([
        styles.homeBlogArticle,
        type === "default" && styles.homeBlogArticleDefault,
        type === "vertical" && styles.homeBlogArticleVertical,
      ])}
      type={type}
    >
      <div
        className={cn([
          styles.homeBlogArticleImage,
          type === "default" && styles.homeBlogArticleImageDefault,
          type === "vertical" && styles.homeBlogArticleImageVertical,
        ])}
      >
        <LazyImage
          alt={article.name}
          src={croppedSrc}
          className={cn([
            styles.homeBlogArticleImageLazyImage,
            type === "default"
              ? styles.homeBlogArticleImageDefaultLazyImage
              : styles.homeBlogArticleImageVerticalLazyImage,
          ])}
        />
      </div>

      <div
        className={cn([
          styles.homeBlogArticleInfo,
          type === "vertical" && styles.homeBlogArticleInfoVertical,
        ])}
      >
        {article.category.name && (
          <span className={styles.homeBlogArticleCategory}>
            {article.category.name}
          </span>
        )}

        <div
          className={styles.homeBlogArticleTitle}
          dangerouslySetInnerHTML={{ __html: article.name }}
        />
      </div>
    </Link>
  );
};

export default Item;
